import { generateWidgetContext } from '../widget-wrapper';

export const OrdersWidgetContext = generateWidgetContext();
